import React from 'react';
import { Card } from 'antd';

export default function MatGapSendbackList() {
  return (
    <Card title="GAP Material - Sendback Transactions">
      {/* TODO: Implement sendback transactions list */}
      Coming soon...
    </Card>
  );
}
